(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["palmy-buy-now"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('palmy-buy-now')) {
    customElements.define('palmy-buy-now', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const form = this.closest('form');
        const nativeButton = form?.querySelector('[data-atc-form]');
        if (!form || !nativeButton || nativeButton.hasAttribute('disabled')) return;
        this.initialized = true;
        this.hidden = false;
        const root = window.Shopify?.routes?.root || '/';
        const button = this.querySelector('button');
        const label = button.querySelector('[data-palmy-buy-label]');
        const totalLabel = button.querySelector('[data-palmy-buy-total]');
        const initialLabel = label.textContent;
        const error = this.querySelector('[role=alert]');
        const status = this.querySelector('[role=status]');
        const quantity = () => Math.max(1, Number(form.querySelector('[name="quantity"]')?.value) || 1);
        const kwd = fils => new Intl.NumberFormat('en-US', { minimumFractionDigits:3, maximumFractionDigits:3 }).format(fils / 1000) + ' KWD';
        const sync = () => { button.disabled = this.pending || nativeButton.disabled || nativeButton.getAttribute('aria-disabled') === 'true'; };
        const renderTotal = () => {
          const state = window.palmyState;
          if (!state || !form.closest('.t4s-section-main-product')) { totalLabel.textContent = ''; return; }
          const percent = window.palmyOffer?.applied ? window.palmyOffer.percent : 0;
          totalLabel.textContent = kwd(Math.round(state.price * quantity() * 10 * (100 - percent) / 100));
        };
        this.observer = new MutationObserver(sync);
        this.observer.observe(nativeButton, { attributes:true, attributeFilter:['disabled','aria-disabled'] });
        sync();
        document.addEventListener('palmy:variant', renderTotal);
        document.addEventListener('palmy:offer', renderTotal);
        form.addEventListener('change', renderTotal);
        form.addEventListener('input', renderTotal);
        renderTotal();
        form.addEventListener('click', event => { if(this.pending){event.preventDefault();event.stopImmediatePropagation();} }, true);
        form.addEventListener('submit', event => { if(this.pending){event.preventDefault();event.stopImmediatePropagation();} }, true);
        const ready = () => {
          error.hidden = true;
          form.palmyFitUpdate?.();
          if(form.palmyFitValidate && !form.palmyFitValidate()) return false;
          if(!form.reportValidity()) return false;
          sync();
          if(button.disabled) return false;
          if(!new FormData(form).get('id')) { error.textContent = this.dataset.unavailable; error.hidden = false; return false; }
          return true;
        };
        const addToCart = async () => {
          const response = await fetch(root + 'cart/add.js', { method:'POST', body:new FormData(form), headers:{Accept:'application/json'} });
          const data = await response.json();
          if(!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : this.dataset.error);
        };
        const run = async () => {
          this.pending = true;
          button.setAttribute('aria-busy','true');
          label.textContent = this.dataset.loading;
          status.textContent = this.dataset.loading;
          sync();
          try {
            await addToCart();
            const offer = window.palmyOffer;
            const code = offer?.applied ? offer.code : '';
            window.location.assign(root + 'checkout' + (code ? '?discount=' + encodeURIComponent(code) : ''));
          } catch(problem) {
            error.textContent = problem instanceof TypeError ? this.dataset.error : problem.message || this.dataset.error;
            error.hidden = false;
            this.pending = false;
            button.removeAttribute('aria-busy');
            label.textContent = initialLabel;
            status.textContent = '';
            sync();
          }
        };
        button.addEventListener('click', () => { if(!this.pending && ready()) run(); });
        window.addEventListener('pageshow', () => { this.pending = false; button.removeAttribute('aria-busy'); label.textContent = initialLabel; status.textContent = ''; sync(); renderTotal(); });
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["palmy-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('palmy-offer')) {
    const offer = window.palmyOffer = window.palmyOffer || { code:'', percent:0, applied:null, pending:null };
    const readCode = () => {
      const match = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
      return match ? decodeURIComponent(match[1]).trim() : '';
    };
    const kwd = fils => new Intl.NumberFormat('en-US', { minimumFractionDigits:3, maximumFractionDigits:3 }).format(fils / 1000) + ' KWD';
    const broadcast = () => {
      document.querySelectorAll('palmy-offer').forEach(element => element.render?.());
      document.dispatchEvent(new CustomEvent('palmy:offer', { detail:offer }));
    };
    const apply = async force => {
      const current = readCode();
      if (current && current.toUpperCase() === offer.code.toUpperCase()) { offer.applied = true; broadcast(); return true; }
      if (current && !force) { offer.applied = false; broadcast(); return false; }
      try {
        const root = window.Shopify?.routes?.root || '/';
        await fetch(root + 'discount/' + encodeURIComponent(offer.code) + '?redirect=' + encodeURIComponent(root + 'cart.js'), { credentials:'same-origin' });
      } catch (error) {}
      offer.applied = readCode().toUpperCase() === offer.code.toUpperCase();
      broadcast();
      return offer.applied;
    };
    offer.apply = apply;
    customElements.define('palmy-offer', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        offer.code = offer.code || this.dataset.code;
        offer.percent = offer.percent || Number(this.dataset.percent) || 0;
        this.button = this.querySelector('[data-offer-copy]');
        this.button.addEventListener('click', () => this.activate());
        this.price = this.querySelector('[data-offer-price]');
        if (this.price) {
          const update = () => { const state = window.palmyState; if (state) this.price.textContent = kwd(Math.round(state.price * 10 * (100 - offer.percent) / 100)); };
          document.addEventListener('palmy:variant', update);
          update();
        }
        if (this.dataset.auto === 'true') { if (!offer.pending) offer.pending = apply(false); }
        else if (offer.applied === null) offer.applied = false;
        this.render();
      }
      render() {
        if (offer.applied === null) return;
        this.toggleAttribute('data-applied', offer.applied);
        if (this.dataset.state === 'copied' || this.dataset.state === 'manual') return;
        const action = this.querySelector('[data-offer-action]');
        const title = this.querySelector('[data-offer-title]');
        const hint = this.querySelector('[data-offer-hint]');
        action.textContent = offer.applied ? this.dataset.appliedLabel : this.dataset.copy;
        title.textContent = offer.applied && this.classList.contains('palmy-offer--bar') ? this.dataset.appliedTitle : this.dataset.title;
        hint.textContent = offer.applied ? this.dataset.appliedHint : this.dataset.hint;
      }
      async activate() {
        if (this.busy) return;
        this.busy = true;
        if (!offer.applied) await apply(true);
        await this.copy();
        this.busy = false;
      }
      async copy() {
        let copied = false;
        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(offer.code);
            copied = true;
          }
        } catch (error) {}
        if (!copied) {
          const input = document.createElement('textarea');
          input.value = offer.code;
          input.setAttribute('readonly', '');
          input.style.cssText = 'position:fixed;top:0;left:-9999px;font-size:16px;';
          document.body.appendChild(input);
          input.select();
          try { copied = document.execCommand('copy'); } catch (error) {}
          input.remove();
          this.button.focus({ preventScroll:true });
        }
        if (copied) {
          document.querySelectorAll('palmy-offer').forEach(element => {
            element.dataset.state = 'copied';
            element.querySelector('[data-offer-action]').textContent = element.dataset.copied;
            element.querySelector('[data-offer-hint]').textContent = element.dataset.success;
          });
          this.querySelector('[data-offer-status]').textContent = offer.applied ? this.dataset.appliedHint : this.dataset.success;
          clearTimeout(this.resetTimer);
          this.resetTimer = setTimeout(() => document.querySelectorAll('palmy-offer').forEach(element => { delete element.dataset.state; element.render(); }), 2200);
        } else if (!offer.applied) {
          this.dataset.state = 'manual';
          this.querySelector('[data-offer-action]').textContent = this.dataset.manual;
          this.querySelector('[data-offer-hint]').textContent = this.dataset.fallback;
          this.querySelector('[data-offer-status]').textContent = this.dataset.fallback;
          const range = document.createRange();
          range.selectNodeContents(this.querySelector('[data-offer-code]'));
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
        } else {
          this.querySelector('[data-offer-status]').textContent = this.dataset.appliedHint;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["palmy-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('palmy-size-guide')) {
    customElements.define('palmy-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.trigger = document.querySelector('[data-palmy-guide-toggle][aria-controls="' + CSS.escape(this.id) + '"]');
        if (!this.trigger) return;
        this.ready = true;
        this.trigger.hidden = false;
        const showSize = size => {
          this.querySelectorAll('[data-guide-size]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.guideSize === size)));
          this.querySelectorAll('[data-guide-measurements]').forEach(panel => { panel.hidden = panel.dataset.guideMeasurements !== size; });
        };
        const close = () => { this.hidden = true; this.trigger.setAttribute('aria-expanded','false'); this.trigger.focus({preventScroll:true}); };
        this.trigger.addEventListener('click', () => {
          if (!this.hidden) { close(); return; }
          const selected = this.trigger.closest('[data-swatch-option]')?.querySelector('[data-current-value]')?.textContent.trim().toUpperCase();
          const aliases = {XSMALL:'XS',SMALL:'S',MEDIUM:'M',MEDUIM:'M',LARGE:'L',XLARGE:'XL',XXLARGE:'XXL'};
          const size = aliases[selected] || selected;
          showSize(['XS','S','M','L','XL','XXL'].includes(size) ? size : 'XS');
          this.hidden = false;
          this.trigger.setAttribute('aria-expanded','true');
        });
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-guide-size]');
          if (button) showSize(button.dataset.guideSize);
          if (event.target.closest('[data-guide-close]')) close();
        });
        this.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); close(); } });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
